import { FeatureFlags } from '../../../common/model/config';

export const c3PrajaFeatureFlags: FeatureFlags = {
  hideBackButton: false,
};
